import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Select, Icon, CnTooltip, CnReadOnly } from '@cainiaofe/cn-ui';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import isNumber from 'lodash/isNumber';
import isEqual from 'lodash/isEqual';
import { func, obj, dom, cascaders, levels, configs, handles, KEYCODE } from "../utils/index";
import Services, { getFullDataByCdn } from "../utils/services";
import { getDetailValueDS, transferObjToAvailable, checkUseDetail } from "../utils/useDetail";
import { preHandlerDataLanguage, getName } from "../utils/languages";
import { getFinalValue } from "../utils/value";
import { ABROAD_CODES } from "../utils/const";
import Footer from "./footer";
import Cascader from "./cascader";
import NotFoundRender from "./components/not-found-render";
import SearchingRender from "./components/searching-render";
import SearchFailedRender from "./components/search-failed-render";
import RegionItemRender from "./components/region-item-render";
import zhCN from "../locale/zh-CN.json";
import "./index.scss";
var bindCtx = func.bindCtx;
var pickOthers = obj.pickOthers;
var getStyle = dom.getStyle;
var normalizeValue = cascaders.normalizeValue,
  genDict = cascaders.genDict,
  processValue = cascaders.processValue,
  forEachEnableNode = cascaders.forEachEnableNode,
  isSiblingOrSelf = cascaders.isSiblingOrSelf,
  isNodeChecked = cascaders.isNodeChecked,
  filterChildValue = cascaders.filterChildValue;
var getFinallyLevel = levels.getFinallyLevel,
  formatCdnDataLevel = levels.formatCdnDataLevel,
  handleCdnDataSkip = levels.handleCdnDataSkip,
  isSkipLevelData = levels.isSkipLevelData;
var checkSDK = configs.checkSDK,
  setMTOPConfig = configs.setMTOPConfig,
  preCheckConfigs = configs.preCheckConfigs,
  mergeGlobalConfig = configs.mergeGlobalConfig;
var handleData = handles.handleData,
  handlerSortData = handles.handlerSortData;

/**
 * CnAddress
 */
var CnAddress = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CnAddress, _Component);
  function CnAddress(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    /**
     * 刷新值数据缓存，删除无效值
     * @param {Arrary | String} curValue 当前值
     */
    _this.refreshValueDataCache = function (curValue) {
      if (curValue) {
        var valueArr = Array.isArray(curValue) ? curValue : [curValue];
        valueArr.length && Object.keys(_this._valueDataCache).forEach(function (v) {
          if (!valueArr.includes(v)) {
            delete _this._valueDataCache[v];
          }
        });
      } else {
        _this._valueDataCache = {};
      }
    };
    _this.doSearch = debounce(function (v) {
      var mergeProps = mergeGlobalConfig(_this.props);
      var showTopLevel = mergeProps.showTopLevel,
        includeList = mergeProps.includeList,
        excludeList = mergeProps.excludeList,
        showDisabledDivision = mergeProps.showDisabledDivision,
        dataLanguage = mergeProps.dataLanguage,
        needSkipLevelData = mergeProps.needSkipLevelData,
        blackList = mergeProps.blackList,
        divisionSort = mergeProps.divisionSort,
        levelConfig = mergeProps.levelConfig,
        isParseSearch = mergeProps.isParseSearch,
        isSearchById = mergeProps.isSearchById,
        isShowAbroad = mergeProps.isShowAbroad,
        searchStrictly = mergeProps.searchStrictly;
      var iso = _this.props.iso;
      var dataSource = _this.state.dataSource;

      // 是否为全部国家
      var isAllIsos = iso === '' || iso === null;
      var maxDataLevel = getFinallyLevel(mergeProps);
      var isOpenParse = isParseSearch && iso === 'CN';
      var p = _this.services.getRegionChainByName;
      p.call(_this.services, {
        id: v,
        divisionToken: v,
        // 搜索时全量搜索，在结果中截取数据
        maxDataLevel: searchStrictly ? maxDataLevel : '',
        iso: iso
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apiRes) {
          var v2n, parseResult, _parseResult$, _parseResult, searchResultIso, shouldSearch, serialPromises;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (apiRes === void 0) {
                  apiRes = [];
                }
                v2n = _this._v2n || []; // 解析查询
                if (!(isOpenParse && apiRes.length === 0)) {
                  _context.next = 7;
                  break;
                }
                _context.next = 5;
                return _this.services.getRegionChainByParse({
                  fullAddress: v,
                  maxLevel: 0,
                  iso: iso
                });
              case 5:
                parseResult = _context.sent;
                if (parseResult && parseResult.length) {
                  apiRes = [parseResult];
                }
              case 7:
                if (!(isSearchById && apiRes.length === 0)) {
                  _context.next = 13;
                  break;
                }
                _context.next = 10;
                return _this.services.getRegionChain({
                  id: v,
                  iso: iso
                });
              case 10:
                _parseResult = _context.sent;
                searchResultIso = (_parseResult$ = _parseResult[0]) === null || _parseResult$ === void 0 ? void 0 : _parseResult$.iso; // 1.非所有国家场景，不能搜索与当前 iso 不一致数据
                if (_parseResult.length === 0 || !isAllIsos && iso !== searchResultIso) {
                  apiRes = [];
                } else {
                  apiRes = [_parseResult];
                }
              case 13:
                // iso指定国家时，且没有设置 showTopLevel 不能搜索第一级
                if (!isAllIsos && !showTopLevel && apiRes.length && apiRes[0].length <= 1) {
                  apiRes = [];
                }
                shouldSearch = [];
                apiRes = apiRes.map(function (o) {
                  var inputRes = o.filter(function (i) {
                    return i;
                  });
                  var start = showTopLevel || isAllIsos ? 0 : 1;
                  var end = maxDataLevel;

                  // 在搜索结果中截取符合当前层级的数据
                  inputRes = inputRes.slice(start, end);

                  // 过滤跳级数据
                  var lastOne = inputRes.at(-1);
                  if (!needSkipLevelData && (lastOne === null || lastOne === void 0 ? void 0 : lastOne.level) > maxDataLevel) return false;
                  if (blackList.length && inputRes.some(function (input) {
                    return blackList.includes(input.id);
                  })) return false;
                  if (!showDisabledDivision && inputRes.some(function (input) {
                    return input.disable;
                  })) return false;
                  if (!iso) {
                    if (excludeList.length && inputRes.some(function (input) {
                      return excludeList.includes(input.iso);
                    })) return false;
                    if (includeList.length && !inputRes.some(function (input) {
                      return includeList.includes(input.iso);
                    })) return false;
                  }
                  shouldSearch = shouldSearch.concat(inputRes);
                  return handleData({
                    isSearch: true,
                    input: inputRes,
                    showDisabledDivision: showDisabledDivision,
                    dataLanguage: dataLanguage,
                    maxDataLevel: maxDataLevel,
                    needSkipLevelData: needSkipLevelData,
                    divisionSort: divisionSort,
                    levelConfig: levelConfig,
                    iso: iso,
                    isShowAbroad: isShowAbroad
                  });
                }).filter(function (i) {
                  return i;
                });

                // sort 将搜索匹配的字段优先展示
                apiRes = apiRes.sort(function (a, b) {
                  return b.at(-1).label.indexOf(v) - a.at(-1).label.indexOf(v);
                });
                serialPromises = function serialPromises(promises) {
                  return promises.reduce(function (prev, next) {
                    return prev.then(next);
                  }, Promise.resolve(dataSource));
                };
                serialPromises(shouldSearch.map(function (item) {
                  if (!v2n[item.id]) {
                    return _this.mergeSource.bind(_assertThisInitialized(_this), item.id);
                  }
                  return;
                })).then(function () {
                  _this.setState({
                    searchLoading: false,
                    searchResult: apiRes
                  });
                });
              case 19:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }, 600);
    _this.setSearchValue = debounce(function (searchValue) {
      var expandCount = _this.state.expandCount;
      _this.setState({
        searchValue: searchValue,
        showExpandCount: Boolean(searchValue) ? 0 : expandCount
      });
    }, 600);
    _this.state = {
      value: [],
      iso: 'CN',
      hasInit: false,
      initLoading: true,
      visible: false,
      dataSource: [],
      showExpandCount: 1,
      expandCount: 1,
      expand: [],
      searchResult: [],
      searchValue: '',
      searchLoading: false,
      mergeAllProps: mergeGlobalConfig(_this.props),
      regionChainForWhitelist: []
    };

    // 缓存选中值数据
    _this._valueDataCache = {};
    bindCtx(_assertThisInitialized(_this), ['handleVisibleChange', 'handleAfterOpen', 'handleSelect', 'handleChange', 'handleClear', 'handleRemove', 'handleSearch', 'getPopup', 'saveSelectRef', 'saveCascaderRef', 'handleKeyDown']);
    return _this;
  }
  CnAddress.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    var st = {};
    if ('value' in props && prevState.hasInit) {
      st.value = transferObjToAvailable(props.value, _extends({}, props));
      return st;
    }
    return null;
  };
  var _proto = CnAddress.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.initCnFilterProps();
    this.init();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;
    var mergeProps = this.state.mergeAllProps;
    var props = mergeProps;

    // value变化时，重新获取数据
    if ('value' in this.props && this.props.value && !isEqual(transferObjToAvailable(this.props.value, _extends({}, props)), prevState.value) && this.state.hasInit) {
      this.setInputValue(this.state.dataSource).then(function () {
        _this2.setState({
          value: transferObjToAvailable(_this2.props.value, _extends({}, props))
        });
      });
    }

    // 切换国家/白名单 重新获取数据
    if (prevProps.iso !== this.props.iso || prevProps.whitelistCode !== this.props.whitelistCode) {
      this.setState({
        value: []
      }, function () {
        _this2.props.onChange && _this2.props.onChange(undefined, null, null);
        _this2.init();
      });
    }
  }

  /**
   * 初始化
   * @returns
   */;
  _proto.init =
  /*#__PURE__*/
  function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var mergeProps, showTopLevel, includeList, excludeList, blackList, maxLevel, showDisabledDivision, propDataLanguage, config, needSkipLevelData, divisionSort, levelConfig, mtopConfig, isShowAbroad, hideSensitiveDivision, iso, dataLanguage, preCheckResult, maxDataLevel, countrys, _res, allCountrys, res, _this$services, _countrys$, _countrys$2, next;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            mergeProps = this.state.mergeAllProps;
            showTopLevel = mergeProps.showTopLevel, includeList = mergeProps.includeList, excludeList = mergeProps.excludeList, blackList = mergeProps.blackList, maxLevel = mergeProps.maxLevel, showDisabledDivision = mergeProps.showDisabledDivision, propDataLanguage = mergeProps.dataLanguage, config = mergeProps.config, needSkipLevelData = mergeProps.needSkipLevelData, divisionSort = mergeProps.divisionSort, levelConfig = mergeProps.levelConfig, mtopConfig = mergeProps.mtopConfig, isShowAbroad = mergeProps.isShowAbroad, hideSensitiveDivision = mergeProps.hideSensitiveDivision;
            iso = this.props.iso;
            this.setState({
              iso: iso
            });

            // 预处理数据语言
            dataLanguage = preHandlerDataLanguage(propDataLanguage); // 预校验
            preCheckResult = preCheckConfigs(mergeProps);
            if (preCheckResult) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return");
          case 8:
            maxDataLevel = getFinallyLevel(mergeProps);
            if (!((config === null || config === void 0 ? void 0 : config.apiModel) === 'cdn')) {
              _context2.next = 13;
              break;
            }
            _context2.next = 12;
            return this.initCdn();
          case 12:
            return _context2.abrupt("return");
          case 13:
            if (!((config === null || config === void 0 ? void 0 : config.apiModel) === 'mtop' || !(config !== null && config !== void 0 && config.apiModel))) {
              _context2.next = 17;
              break;
            }
            _context2.next = 16;
            return checkSDK();
          case 16:
            // 自定义mtop配置
            setMTOPConfig(mtopConfig);
          case 17:
            this.services = new Services({
              config: _extends({}, config || {}, {
                iso: iso || 'CN',
                hideSensitiveDivision: hideSensitiveDivision
              })
            });
            countrys = [];
            _context2.next = 21;
            return this._getChainData(this.services);
          case 21:
            if (!iso) {
              _context2.next = 28;
              break;
            }
            _context2.next = 24;
            return this.services.getTopLevelInfo({
              iso: iso
            });
          case 24:
            _res = _context2.sent;
            countrys.push(_res);
            _context2.next = 32;
            break;
          case 28:
            _context2.next = 30;
            return this.services.getTopLevelList({});
          case 30:
            allCountrys = _context2.sent;
            allCountrys.forEach(function (item) {
              if (includeList.indexOf(item.iso) != -1) {
                countrys.push(item);
              }
              if (!includeList.length) {
                countrys.push(item);
              }
              if (excludeList.indexOf(item.iso) != -1) {
                countrys = countrys.filter(function (country) {
                  return country.iso !== item.iso;
                });
              }
            });
          case 32:
            if (!(iso && !showTopLevel)) {
              _context2.next = 41;
              break;
            }
            _context2.next = 35;
            return (_this$services = this.services) === null || _this$services === void 0 ? void 0 : _this$services.getChildren({
              id: (_countrys$ = countrys[0]) === null || _countrys$ === void 0 ? void 0 : _countrys$.id,
              maxLevel: maxLevel,
              iso: iso || ((_countrys$2 = countrys[0]) === null || _countrys$2 === void 0 ? void 0 : _countrys$2.iso)
            });
          case 35:
            next = _context2.sent;
            if (next) {
              _context2.next = 38;
              break;
            }
            return _context2.abrupt("return");
          case 38:
            res = handleData({
              input: next || [],
              showDisabledDivision: showDisabledDivision,
              dataLanguage: dataLanguage,
              maxDataLevel: maxDataLevel,
              needSkipLevelData: needSkipLevelData,
              divisionSort: divisionSort,
              iso: iso,
              isShowAbroad: isShowAbroad
            });
            _context2.next = 42;
            break;
          case 41:
            res = handleData({
              input: countrys,
              showDisabledDivision: showDisabledDivision,
              dataLanguage: dataLanguage,
              maxDataLevel: maxDataLevel,
              needSkipLevelData: needSkipLevelData,
              divisionSort: divisionSort,
              levelConfig: levelConfig,
              iso: iso,
              isShowAbroad: isShowAbroad
            });
          case 42:
            // 黑名单过滤
            res = res.filter(function (item) {
              return !blackList.includes(item.value);
            });

            // 白名单
            res = this._fiterDataForWhitelist(res);
            this.setState({
              dataSource: res
            });
            this.preHandleData(res);
            _context2.next = 48;
            return this.setInputValue(res);
          case 48:
            this.setState({
              hasInit: true,
              initLoading: false,
              value: getFinalValue(mergeProps)
            });
            return _context2.abrupt("return", res);
          case 50:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function init() {
      return _init.apply(this, arguments);
    }
    return init;
  }()
  /**
   * cdn模式初始化
   */
  ;
  _proto.initCdn =
  /*#__PURE__*/
  function () {
    var _initCdn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var mergeProps, config, propDataLanguage, showTopLevel, showDisabledDivision, includeList, excludeList, blackList, divisionSort, isShowAbroad, iso, dataLanguage, fullFlatDataByCdn, fullFlatData, map, topMap, res, _topMap$iso;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            mergeProps = this.state.mergeAllProps;
            config = mergeProps.config, propDataLanguage = mergeProps.dataLanguage, showTopLevel = mergeProps.showTopLevel, showDisabledDivision = mergeProps.showDisabledDivision, includeList = mergeProps.includeList, excludeList = mergeProps.excludeList, blackList = mergeProps.blackList, divisionSort = mergeProps.divisionSort, isShowAbroad = mergeProps.isShowAbroad;
            iso = this.props.iso; // 预处理数据语言
            dataLanguage = preHandlerDataLanguage(propDataLanguage);
            _context3.next = 6;
            return getFullDataByCdn(config.cdnUrl);
          case 6:
            fullFlatDataByCdn = _context3.sent;
            // 排序
            // 此处必须为深拷贝，否则初始化多个文件时会导致全局数据异常
            fullFlatData = handlerSortData(cloneDeep(fullFlatDataByCdn), divisionSort, dataLanguage);
            map = {};
            topMap = {};
            fullFlatData.map(function (i) {
              if (!i.parentId && !topMap[i.iso]) topMap[i.iso] = i;
              if (!showDisabledDivision && i.disable) return;
              if (!map[i.id]) map[i.id] = i;
              if (!i.leaf) i.children = [];
              var _getName = getName(i, dataLanguage),
                label = _getName.name;
              i.value = i.id;
              i.label = label;
              i.rawLevel = i.level;
            }).filter(function (i) {
              return i;
            });
            fullFlatData.map(function (i) {
              var _map$i$parentId;
              if (!showDisabledDivision && i.disable) return;
              if (blackList.includes(i.id)) return;
              if (!isShowAbroad && ABROAD_CODES.includes(i.id)) return;
              if (map[i.parentId] && !((_map$i$parentId = map[i.parentId]) !== null && _map$i$parentId !== void 0 && _map$i$parentId.leaf)) {
                map[i.parentId].children.push(i);
              }
            });
            res = [];
            if (showTopLevel) {
              if (iso) {
                res = [topMap[iso]];
              } else {
                res = Object.values(topMap);
                if (includeList.length) {
                  includeList.map(function (iso) {
                    res.push(topMap[iso]);
                  });
                } else {
                  res = Object.values(topMap);
                }
                if (excludeList.length) {
                  res = res.filter(function (country) {
                    return excludeList.indexOf(country.iso);
                  });
                }
              }
            } else {
              res = ((_topMap$iso = topMap[iso]) === null || _topMap$iso === void 0 ? void 0 : _topMap$iso.children) || [];
            }

            // 处理 level
            res = formatCdnDataLevel(res, mergeProps);
            // 处理跳级数据
            res = handleCdnDataSkip(res, mergeProps);
            this.preHandleData(res);
            this.setState({
              dataSource: res,
              value: getFinalValue(mergeProps),
              hasInit: true,
              initLoading: false
            });
          case 18:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function initCdn() {
      return _initCdn.apply(this, arguments);
    }
    return initCdn;
  }()
  /**
   * 初始化 cnFilter 自定义tag渲染
   */
  ;
  _proto.initCnFilterProps = function initCnFilterProps() {
    var _this3 = this;
    var mergeProps = this.state.mergeAllProps;
    var itemPropsRef = this.props.itemPropsRef;
    if (itemPropsRef) {
      itemPropsRef.current = {
        renderSelected: function renderSelected(key, value, itemLabel) {
          return /*#__PURE__*/React.createElement(RegionItemRender, {
            value: value,
            itemLabel: itemLabel,
            outerProps: mergeProps,
            getData: _this3.getData.bind(_this3)
          });
        }
      };
    }
  };
  _proto.preHandleData = function preHandleData(data, immutable) {
    var _data = immutable ? cloneDeep(data) : data;
    try {
      return this._flatDataSource(_data);
    } catch (err) {
      if ((err.message || '').match('Cannot assign to read only property')) {
        console.error(err.message, 'try to set immutable to true to allow immutable dataSource');
      }
      throw err;
    }
  }

  /**
   *  获取白名单编码区划链，用于过滤使用
   */;
  _proto._getChainData =
  /*#__PURE__*/
  function () {
    var _getChainData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(services) {
      var _this$props, whitelistCode, iso, regionChainForWhitelist;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _this$props = this.props, whitelistCode = _this$props.whitelistCode, iso = _this$props.iso;
            regionChainForWhitelist = [];
            if (!whitelistCode) {
              _context4.next = 8;
              break;
            }
            _context4.next = 5;
            return services.getRegionChain({
              id: whitelistCode,
              iso: iso
            });
          case 5:
            regionChainForWhitelist = _context4.sent;
            _context4.next = 9;
            break;
          case 8:
            regionChainForWhitelist = [];
          case 9:
            return _context4.abrupt("return", this.setState({
              regionChainForWhitelist: regionChainForWhitelist
            }));
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function _getChainData(_x2) {
      return _getChainData2.apply(this, arguments);
    }
    return _getChainData;
  }()
  /**
   * 过滤白名单区划
   * todo: cdn模式
   */
  ;
  _proto._fiterDataForWhitelist = function _fiterDataForWhitelist(res) {
    var _regionChain = this.state.regionChainForWhitelist;
    if (_regionChain.length > 0) {
      var cur = res[0];
      var l = (cur === null || cur === void 0 ? void 0 : cur.rawLevel) || (cur === null || cur === void 0 ? void 0 : cur.level);
      var findData = _regionChain.find(function (o) {
        return o.level === l;
      });
      if (findData) {
        return res.filter(function (item) {
          return (item.value || item.id) === findData.id;
        });
      }
    }
    return res;
  };
  _proto._flatDataSource = function _flatDataSource(data, prefix, v2n, p2n) {
    var _this4 = this;
    if (prefix === void 0) {
      prefix = '0';
    }
    if (v2n === void 0) {
      v2n = {};
    }
    if (p2n === void 0) {
      p2n = {};
    }
    data.forEach(function (item, index) {
      var value = item.value,
        children = item.children;
      var pos = prefix + "-" + index;
      var newValue = String(value);
      item.value = newValue;
      v2n[newValue] = p2n[pos] = _extends({}, item, {
        pos: pos,
        _source: item
      });
      if (children && children.length) {
        _this4._flatDataSource(children, pos, v2n, p2n);
      }
    });
    this._v2n = v2n;
    this._p2n = p2n;
    return {
      v2n: v2n,
      p2n: p2n
    };
  }

  /**
   * @desc 当默认值初始化后，如果开启了 useDetailValue, 且传入值为 string 或 [string]，则默认转化输出格式
   * @returns
   */;
  _proto._formatOutputAfterInit = function _formatOutputAfterInit() {
    var _this5 = this;
    var mergeProps = this.state.mergeAllProps;
    var value;
    var multiple = mergeProps.multiple,
      checkStrictly = mergeProps.checkStrictly,
      onChange = mergeProps.onChange,
      useDetailValue = mergeProps.useDetailValue,
      useDetailMap = mergeProps.useDetailMap;
    value = getFinalValue(mergeProps);
    if (multiple) {
      var extra;
      if (mergeProps.onChange) {
        var data = this.getData(value);
        var checked = false;
        var indeterminateValue = this.getIndeterminate(value);
        var indeterminateData = this.getData(indeterminateValue);
        if (checkStrictly) {
          extra = {
            checked: checked,
            currentData: null,
            checkedData: data,
            indeterminateData: indeterminateData
          };
        } else {
          var checkedValue = this.completeValue(value);
          var checkedData = this.getData(checkedValue);
          if (checkedData.filter(function (ii) {
            return ii;
          }).length !== value.length) return;
          var chainData = [];
          data.forEach(function (item) {
            var filterChainData = indeterminateData.filter(
            // 根据pos匹配父级，从其实配置匹配到才算成功，中间位置的无效
            function (o) {
              return item.pos.indexOf(o.pos) === 0;
            });
            filterChainData.push(item);
            filterChainData.sort(function (a, b) {
              return a.level - b.level;
            });
            chainData.push(filterChainData);
          });
          extra = {
            checked: checked,
            currentData: null,
            checkedData: checkedData,
            indeterminateData: indeterminateData,
            chainData: chainData
          };
        }

        // 详细数据处理
        onChange(getDetailValueDS(value, data.filter(function (item) {
          return item;
        }), extra, multiple, useDetailMap, useDetailValue), data, extra);
      }
    } else {
      var _data2 = this._v2n[value];
      if (!_data2) return;
      var nums = _data2.pos.split('-');
      var selectedPath = nums.slice(1).reduce(function (ret, num, index) {
        var p = nums.slice(0, index + 2).join('-');
        ret.push(_this5._p2n[p]);
        return ret;
      }, []);
      var _extra = {
        selectedPath: selectedPath
      };
      onChange(getDetailValueDS(value, _data2, _extra, multiple, useDetailMap, useDetailValue), _data2, _extra);
    }
  };
  _proto.setInputValue = /*#__PURE__*/function () {
    var _setInputValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(datas) {
      var _this6 = this;
      var mergeProps, multiple, _mergeProps$config$ma, maxLength, v, newValue, isArray, arr, shouldLoad, propsV;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            mergeProps = mergeGlobalConfig(this.props);
            multiple = mergeProps.multiple, _mergeProps$config$ma = mergeProps.config.maxLength, maxLength = _mergeProps$config$ma === void 0 ? 50 : _mergeProps$config$ma;
            v = getFinalValue(mergeProps);
            newValue = normalizeValue(v);
            isArray = typeof newValue === 'object' && Object.prototype.toString.call(newValue) === '[object Array]';
            arr = newValue || [];
            if (!isArray && newValue) {
              arr = [newValue];
            }
            shouldLoad = [];
            arr.forEach(function (o) {
              var exits = (_this6._v2n || {})[o];
              !exits && shouldLoad.push(o);
            });
            // 回填会触发  只是选不会触发
            if (!(shouldLoad.length > maxLength)) {
              _context5.next = 12;
              break;
            }
            console.error("value's length is too large, please use cdn data");
            return _context5.abrupt("return");
          case 12:
            _context5.next = 14;
            return Promise.all(shouldLoad.map(function (i) {
              return _this6.mergeSource(i, datas);
            }));
          case 14:
            // 初始化时，如果开启 useDetailValue 且默认数据为 string 或 [string] 需要处理一次数据为 object 或 [object]
            // 避免在 form 中初始 getValue 格式异常
            propsV = 'value' in mergeProps ? this.props.value : this.props.defaultValue;
            if (mergeProps.useDetailValue && !this.hasNotSelected && propsV && !checkUseDetail(propsV, multiple)) {
              this._formatOutputAfterInit();
            }
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function setInputValue(_x3) {
      return _setInputValue.apply(this, arguments);
    }
    return setInputValue;
  }();
  _proto.mergeSource = /*#__PURE__*/function () {
    var _mergeSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(code, datas) {
      var _this$services2,
        _res$count,
        _this7 = this;
      var mergeProps, showTopLevel, needSkipLevelData, maxLevel, showDisabledDivision, dataLanguage, divisionSort, levelConfig, isShowAbroad, iso, maxDataLevel, v2n, newData, rawRes, res, count, topCode, top, children, _this$services3, secondLevel, deep;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            mergeProps = mergeGlobalConfig(this.props);
            showTopLevel = mergeProps.showTopLevel, needSkipLevelData = mergeProps.needSkipLevelData, maxLevel = mergeProps.maxLevel, showDisabledDivision = mergeProps.showDisabledDivision, dataLanguage = mergeProps.dataLanguage, divisionSort = mergeProps.divisionSort, levelConfig = mergeProps.levelConfig, isShowAbroad = mergeProps.isShowAbroad;
            iso = this.props.iso;
            maxDataLevel = getFinallyLevel(mergeProps);
            v2n = this._v2n;
            if (!v2n[code]) {
              _context7.next = 7;
              break;
            }
            return _context7.abrupt("return", datas);
          case 7:
            newData = [].concat(datas).splice(0);
            _context7.next = 10;
            return (_this$services2 = this.services) === null || _this$services2 === void 0 ? void 0 : _this$services2.getRegionChain({
              id: code,
              maxLevel: maxLevel,
              iso: iso
            });
          case 10:
            _context7.t0 = _context7.sent;
            if (_context7.t0) {
              _context7.next = 13;
              break;
            }
            _context7.t0 = [];
          case 13:
            rawRes = _context7.t0;
            res = rawRes.filter(function (i) {
              return i;
            }); // 传入不存在的id时，终止
            if (!(res.length === 0)) {
              _context7.next = 18;
              break;
            }
            console.error('CnAddress Error: maybe divisionId is not existed');
            return _context7.abrupt("return");
          case 18:
            count = iso && !showTopLevel ? 1 : 0;
            topCode = (_res$count = res[count]) === null || _res$count === void 0 ? void 0 : _res$count.id;
            if (topCode) {
              _context7.next = 22;
              break;
            }
            return _context7.abrupt("return");
          case 22:
            top = (this._v2n || {})[topCode];
            if (!(maxLevel === 1)) {
              _context7.next = 25;
              break;
            }
            return _context7.abrupt("return");
          case 25:
            children = (top === null || top === void 0 ? void 0 : top.children) || [];
            if (!(children.length === 0)) {
              _context7.next = 32;
              break;
            }
            _context7.next = 29;
            return (_this$services3 = this.services) === null || _this$services3 === void 0 ? void 0 : _this$services3.getChildren({
              id: topCode,
              maxLevel: maxLevel
            });
          case 29:
            secondLevel = _context7.sent;
            children = handleData({
              input: secondLevel || [],
              isLeaf: maxLevel === 2,
              parentId: topCode,
              showDisabledDivision: showDisabledDivision,
              dataLanguage: dataLanguage,
              maxDataLevel: maxDataLevel,
              needSkipLevelData: needSkipLevelData,
              divisionSort: divisionSort,
              levelConfig: levelConfig,
              iso: iso,
              isShowAbroad: isShowAbroad
            });
            // 白名单过滤
            children = this._fiterDataForWhitelist(children);
          case 32:
            count++;
            deep = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(children) {
                var _res$count2;
                var nextCode, next, _this7$services, nextChilds;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      nextCode = (_res$count2 = res[count]) === null || _res$count2 === void 0 ? void 0 : _res$count2.id;
                      next = children.find(function (o) {
                        return (o === null || o === void 0 ? void 0 : o.value) === nextCode;
                      });
                      if (!(next && !next.children)) {
                        _context6.next = 8;
                        break;
                      }
                      _context6.next = 5;
                      return (_this7$services = _this7.services) === null || _this7$services === void 0 ? void 0 : _this7$services.getChildren({
                        id: nextCode,
                        maxLevel: maxLevel,
                        divisionLevel: next.rawLevel || next.level
                      });
                    case 5:
                      nextChilds = _context6.sent;
                      // 白名单过滤
                      nextChilds = _this7._fiterDataForWhitelist(nextChilds);

                      // 改由数据层级判断 isLeaf
                      next.children = handleData({
                        input: nextChilds || [],
                        parentId: nextCode,
                        showDisabledDivision: showDisabledDivision,
                        dataLanguage: dataLanguage,
                        maxDataLevel: maxDataLevel,
                        needSkipLevelData: needSkipLevelData,
                        divisionSort: divisionSort,
                        levelConfig: levelConfig,
                        iso: iso,
                        isShowAbroad: isShowAbroad
                      });
                    case 8:
                      count++;
                      if (!(maxLevel >= count + 1 && res.length >= count + 2)) {
                        _context6.next = 12;
                        break;
                      }
                      _context6.next = 12;
                      return deep(next.children);
                    case 12:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function deep(_x6) {
                return _ref2.apply(this, arguments);
              };
            }(); // 某些情况不需要获取子级，例如maxLevel=2时，区分单独一个国家和多个国家
            if (!(iso && !showTopLevel && maxLevel !== count || iso && showTopLevel && maxLevel !== count + 1 || !iso && maxLevel !== count + 1)) {
              _context7.next = 37;
              break;
            }
            _context7.next = 37;
            return deep(children);
          case 37:
            newData.some(function (item) {
              if (item.value === topCode) {
                item.children = children;
                return true;
              }
            });
            this.setState({
              dataSource: newData
            });
            this.preHandleData(newData);
            return _context7.abrupt("return", newData);
          case 41:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    function mergeSource(_x4, _x5) {
      return _mergeSource.apply(this, arguments);
    }
    return mergeSource;
  }();
  _proto.updateCache = function updateCache(dataSource) {
    var _this8 = this;
    this._v2n = {};
    this._p2n = {};
    var loop = function loop(data, prefix) {
      if (prefix === void 0) {
        prefix = '0';
      }
      return data.forEach(function (item, index) {
        var value = item.value,
          children = item.children;
        var pos = prefix + "-" + index;
        _this8._v2n[value] = _this8._p2n[pos] = _extends({}, item, {
          pos: pos
        });
        if (children && children.length) {
          loop(children, pos);
        }
      });
    };
    loop(dataSource);
  };
  _proto.flatValue = function flatValue(value) {
    var _this9 = this;
    var getDepth = function getDepth(v) {
      var pos = _this9.getPos(v);
      if (!pos) {
        return 0;
      }
      return pos.split('-').length;
    };
    var newValue = value.slice(0).sort(function (prev, next) {
      return getDepth(prev) - getDepth(next);
    });
    for (var i = 0; i < newValue.length; i++) {
      for (var j = 0; j < newValue.length; j++) {
        if (i !== j && this.isDescendantOrSelf(this.getPos(newValue[i]), this.getPos(newValue[j]))) {
          newValue.splice(j, 1);
          j--;
        }
      }
    }
    return newValue;
  };
  _proto.isDescendantOrSelf = function isDescendantOrSelf(currentPos, targetPos) {
    if (!currentPos || !targetPos) {
      return false;
    }
    var currentNums = currentPos.split('-');
    var targetNums = targetPos.split('-');
    return currentNums.length <= targetNums.length && currentNums.every(function (num, index) {
      return num === targetNums[index];
    });
  };
  _proto.getExpandedValue = function getExpandedValue(v, _v2n, _p2n) {
    var _this10 = this;
    if (!v || !_v2n[v]) {
      return [];
    }
    var pos = _v2n[v].pos;
    if (pos.split('-').length === 2) {
      return [];
    }
    var expandedMap = {};
    Object.keys(_p2n).forEach(function (p) {
      if (_this10.isDescendantOrSelf(p, pos) && p !== pos) {
        expandedMap[_p2n[p].value] = p;
      }
    });
    return Object.keys(expandedMap).sort(function (prev, next) {
      return expandedMap[prev].split('-').length - expandedMap[next].split('-').length;
    });
  };
  _proto.getValue = function getValue(pos) {
    return this._p2n[pos] ? this._p2n[pos].value : null;
  };
  _proto.getPos = function getPos(value) {
    return this._v2n[value] ? this._v2n[value].pos : null;
  };
  _proto.getData = function getData(value) {
    var _this11 = this;
    return value.map(function (v) {
      return _this11._v2n[v] || _this11._valueDataCache[v];
    });
  };
  _proto.getLabelPath = function getLabelPath(data) {
    var _this12 = this;
    var nums = data.pos.split('-');
    return nums.slice(1).reduce(function (ret, num, index) {
      var p = nums.slice(0, index + 2).join('-');
      ret.push(_this12._p2n[p].label);
      return ret;
    }, []);
  };
  _proto.getSingleData = function getSingleData(value) {
    var mergeProps = this.props;
    if (!value.length) {
      return null;
    }
    if (Array.isArray(value)) value = value[0];
    var data = this._v2n[value];
    if (data) {
      var labelPath = this.getLabelPath(data);
      var displayRender = mergeProps.displayRender || function (labels) {
        return labels.join(' / ');
      };
      data = _extends({}, data, {
        label: displayRender(labelPath, data)
      });

      // 防止传入的value从数据源里移除了
      this._valueDataCache[value] = data;
      this.refreshValueDataCache(value);
    } else {
      data = this._valueDataCache[value];
    }
    return data || {
      value: value
    };
  };
  _proto.getMultipleData = function getMultipleData(value) {
    var _this13 = this;
    if (!value.length) {
      return null;
    }
    var displayRender = this.props.displayRender;
    // 此处移除了 flatValue 相关处理，性能较差
    var flatValue = value;
    var data = flatValue.map(function (v) {
      var item = _this13._v2n[v];
      if (item) {
        _this13._valueDataCache[v] = item;
      } else {
        item = _this13._valueDataCache[v];
      }
      return item || {
        value: v
      };
    });
    if (displayRender) {
      data = data.map(function (item) {
        if (!item.pos || !(item.value in _this13._v2n)) {
          return item;
        }
        var labelPath = _this13.getLabelPath(item);
        var newItem = _extends({}, item, {
          label: displayRender(labelPath, item)
        });
        _this13._valueDataCache[item.value] = newItem;
        return newItem;
      });
    }
    return data;
  };
  _proto.getIndeterminate = function getIndeterminate(value) {
    var _this14 = this;
    var indeterminate = [];
    var positions = value.map(this.getPos.bind(this));
    positions.forEach(function (pos) {
      if (!pos) {
        return false;
      }
      var nums = pos.split('-');
      for (var i = nums.length; i > 2; i--) {
        var parentPos = nums.slice(0, i - 1).join('-');
        var parentValue = _this14.getValue(parentPos);
        if (indeterminate.indexOf(parentValue) === -1) {
          indeterminate.push(parentValue);
        }
      }
    });
    return indeterminate;
  };
  _proto.saveSelectRef = function saveSelectRef(ref) {
    this.select = ref;
  };
  _proto.saveCascaderRef = function saveCascaderRef(ref) {
    this.cascader = ref;
  };
  _proto.completeValue = function completeValue(value) {
    var newValue = [];
    var flatValue = value;
    var ps = Object.keys(this._p2n);
    for (var i = 0; i < ps.length; i++) {
      for (var j = 0; j < flatValue.length; j++) {
        var v = flatValue[j];
        if (this.isDescendantOrSelf(this.getPos(v), ps[i])) {
          newValue.push(this.getValue(ps[i]));
          ps.splice(i, 1);
          i--;
          break;
        }
      }
    }
    return newValue;
  };
  _proto.isLeaf = function isLeaf(data) {
    var mergeProps = mergeGlobalConfig(this.props);
    return !(data.children && data.children.length || !!mergeProps.loadData && !data.isLeaf);
  };
  _proto.handleVisibleChange = function handleVisibleChange(visible, type) {
    var mergeProps = this.props;
    this.setState({
      visible: visible
    });
    if (!visible) {
      this.setState({
        expand: [],
        expandCount: 1,
        showExpandCount: 1,
        searchValue: ''
      });
    } else {
      var currentValue = normalizeValue(this.state.value);
      var v = currentValue === null || currentValue === void 0 ? void 0 : currentValue[0];
      if (v) {
        var currentExpandedValue = this.getExpandedValue(v, this._v2n, this._p2n);

        // 设置展开
        this.setState({
          expand: currentExpandedValue,
          showExpandCount: currentExpandedValue.length + 1
        });
      }
    }
    if (['fromCascader', 'keyboard'].indexOf(type) !== -1 && !visible) {
      this.select.focusInput();
    }
    mergeProps.onVisibleChange(visible, type);
  };
  _proto.handleKeyDown = function handleKeyDown(e) {
    var mergeProps = mergeGlobalConfig(this.props);
    var onKeyDown = mergeProps.onKeyDown;
    var visible = this.state.visible;
    if (onKeyDown) {
      onKeyDown(e);
    }
    if (!visible) {
      return;
    }
    switch (e.keyCode) {
      case KEYCODE.UP:
      case KEYCODE.DOWN:
        this.cascader.setFocusValue();
        e.preventDefault();
        break;
      default:
        break;
    }
  };
  _proto.getPopup = function getPopup(ref) {
    var mergeProps = mergeGlobalConfig(this.props);
    this.popup = ref;
    if (typeof mergeProps.popupProps.ref === 'function') {
      mergeProps.popupProps.ref(ref);
    }
  };
  _proto.handleAfterOpen = function handleAfterOpen() {
    if (!this.popup) return;
    var mergeProps = mergeGlobalConfig(this.props);
    var prefix = mergeProps.prefix,
      popupProps = mergeProps.popupProps;
    var dropDownNode = this.popup.getInstance().overlay.getInstance().getContentNode();
    var cascaderNode = dropDownNode.querySelector("." + prefix + "cascader");
    if (cascaderNode) {
      this.cascaderHeight = getStyle(cascaderNode, 'height');
    }
    if (typeof popupProps.afterOpen === 'function') {
      popupProps.afterOpen();
    }
  };
  _proto.handleSelect = function handleSelect(value, data) {
    var mergeProps = mergeGlobalConfig(this.props);
    var multiple = mergeProps.multiple,
      changeOnSelect = mergeProps.changeOnSelect;
    var _this$state = this.state,
      visible = _this$state.visible,
      searchValue = _this$state.searchValue;
    var currentMaxLevelData = getFinallyLevel(mergeProps);
    var isLastLevel = data.level === currentMaxLevelData || data.isLeaf;

    // 是否进行选择/编辑操作
    this.hasNotSelected = true;

    // 单选模式下，搜索区划非最后一级时，不选中,expand
    // 最后一级判断条件有两个，maxLevel与当前搜索区划是否一致 或者 区划已经是最后一级
    if (!multiple && !isLastLevel) {
      var currentExpandedValue = this.getExpandedValue(value, this._v2n, this._p2n);
      currentExpandedValue.push(value);
      this.setState({
        expand: currentExpandedValue,
        showExpandCount: currentExpandedValue.length + 1,
        searchValue: ''
      });
      return;
    }
    if (!multiple && (!changeOnSelect || this.isLeaf(data) || !!searchValue)) {
      this.handleVisibleChange(!visible, 'fromCascader');
    }
  };
  _proto.handleChange = function handleChange(value, data, extra) {
    var _this15 = this;
    var mergeProps = mergeGlobalConfig(this.props);
    var multiple = mergeProps.multiple,
      onChange = mergeProps.onChange,
      changeOnSelect = mergeProps.changeOnSelect,
      useDetailValue = mergeProps.useDetailValue,
      useDetailMap = mergeProps.useDetailMap;
    var _this$state2 = this.state,
      searchValue = _this$state2.searchValue,
      stateValue = _this$state2.value;
    var st = {};
    var currentMaxLevelData = getFinallyLevel(mergeProps);
    var isLastLevel = data.level === currentMaxLevelData || data.isLeaf;

    // 是否进行选择/编辑操作
    this.hasNotSelected = true;

    // 单选模式下，搜索区划非最后一级时，不选中
    // changeOnSelect=true，点击即选中
    if (!multiple && !changeOnSelect && !isLastLevel) return;
    if (multiple && stateValue && Array.isArray(stateValue)) {
      var noExistedValues = stateValue.filter(function (v) {
        return !_this15._v2n[v];
      });

      // filter duplicated non-existent value
      if (noExistedValues.length > 0) {
        value = value.filter(function (v) {
          return !(noExistedValues.indexOf(v) >= 0);
        });
      }
      value = [].concat(noExistedValues, value);
      // onChange 中的 data 参数也应该保留不存在的 value 的数据
      // 在 dataSource 异步加载的情况下，会出现value重复的现象，需要去重
      data = [].concat(noExistedValues.map(function (v) {
        return _this15._valueDataCache[v];
      }).filter(function (v) {
        return v;
      }), data).filter(function (current, index, arr) {
        return index === arr.indexOf(current);
      });
      // 更新缓存
      this.refreshValueDataCache(value);
    }
    if (!('value' in mergeProps)) {
      st.value = value;
    }
    if (!multiple && searchValue) {
      st.searchValue = '';
    }
    if (Object.keys(st).length) {
      this.setState(st);
    }
    if (onChange) {
      if (useDetailValue) {
        onChange(getDetailValueDS(value, data, extra, multiple, useDetailMap, useDetailValue), data, extra);
      } else {
        onChange(value, data, extra);
      }
    }
    if (searchValue && this.select) {
      this.select.handleSearchClear();
    }
  };
  _proto.handleClear = function handleClear() {
    var mergeProps = mergeGlobalConfig(this.props);
    // 单选时点击清空按钮
    var hasClear = mergeProps.hasClear,
      multiple = mergeProps.multiple,
      treeCheckable = mergeProps.treeCheckable;
    if (hasClear && (!multiple || !treeCheckable)) {
      if (!('value' in mergeProps)) {
        this.setState({
          value: []
        });
      }
      mergeProps.onChange(undefined, null, null);
    }
  };
  _proto.handleRemove = function handleRemove(currentData) {
    var mergeProps = mergeGlobalConfig(this.props);
    var currentValue = currentData.value;
    var value;

    // 是否进行选择/编辑操作
    this.hasNotSelected = true;
    var multiple = mergeProps.multiple,
      checkStrictly = mergeProps.checkStrictly,
      onChange = mergeProps.onChange,
      useDetailValue = mergeProps.useDetailValue,
      useDetailMap = mergeProps.useDetailMap;
    if (multiple) {
      value = [].concat(this.state.value);
      value.splice(value.indexOf(currentValue), 1);
      var extra;
      if (mergeProps.onChange) {
        var data = this.getData(value);
        var checked = false;
        var indeterminateValue = this.getIndeterminate(value);
        var indeterminateData = this.getData(indeterminateValue);
        if (checkStrictly) {
          extra = {
            checked: checked,
            currentData: currentData,
            checkedData: data,
            indeterminateData: indeterminateData
          };
        } else {
          var checkedValue = this.completeValue(value);
          var checkedData = this.getData(checkedValue);
          var chainData = [];
          data.forEach(function (item) {
            var filterChainData = indeterminateData.filter(
            // 根据pos匹配父级，从其实配置匹配到才算成功，中间位置的无效
            function (o) {
              return item.pos.indexOf(o.pos) === 0;
            });
            filterChainData.push(item);
            filterChainData.sort(function (a, b) {
              return a.level - b.level;
            });
            chainData.push(filterChainData);
          });
          extra = {
            checked: checked,
            currentData: currentData,
            checkedData: checkedData,
            indeterminateData: indeterminateData,
            chainData: chainData
          };
        }

        // 详细数据处理
        if (useDetailValue) {
          onChange(getDetailValueDS(value, data, extra, multiple, useDetailMap, useDetailValue), data, extra);
        } else {
          onChange(value, data, extra);
        }
      }
    } else {
      value = [];
      onChange(null, null);
    }
    if (!('value' in mergeProps)) {
      this.setState({
        value: value
      });
    }
    this.refreshValueDataCache(value);
  };
  _proto.handleSearch = function handleSearch(searchValue) {
    var mergeProps = mergeGlobalConfig(this.props);
    var _mergeProps$config$ap = mergeProps.config.apiModel,
      apiModel = _mergeProps$config$ap === void 0 ? 'mtop' : _mergeProps$config$ap;
    var searchResult = this.state.searchResult;
    if (apiModel === 'mtop' || apiModel === 'api') {
      if (searchValue) {
        this.doSearch(searchValue);
      }
      this.setState({
        searchLoading: Boolean(searchValue),
        searchResult: Boolean(searchValue) ? searchResult : []
      });
    }
    this.setSearchValue(searchValue);
    mergeProps.onSearch && mergeProps.onSearch(searchValue);
  };
  _proto.getPath = function getPath(pos) {
    var items = [];
    var nums = pos.split('-');
    if (nums === 2) {
      items.push(this._p2n[pos]);
    } else {
      for (var i = 1; i < nums.length; i++) {
        var p = nums.slice(0, i + 1).join('-');
        items.push(this._p2n[p]);
      }
    }
    return items;
  };
  _proto.filterItems = function filterItems() {
    var _this16 = this;
    var mergeProps = mergeGlobalConfig(this.props);
    var multiple = mergeProps.multiple,
      changeOnSelect = mergeProps.changeOnSelect,
      canOnlyCheckLeaf = mergeProps.canOnlyCheckLeaf,
      filter = mergeProps.filter;
    var searchValue = this.state.searchValue;
    var items = Object.keys(this._p2n).map(function (p) {
      return _this16._p2n[p];
    });
    if (!multiple && !changeOnSelect || multiple && canOnlyCheckLeaf) {
      items = items.filter(function (item) {
        return !item.children || !item.children.length;
      });
    }
    return items.map(function (item) {
      return _this16.getPath(item.pos);
    }).filter(function (path) {
      return filter(searchValue, path);
    });
  };
  _proto.renderNotFound = function renderNotFound() {
    var mergeProps = mergeGlobalConfig(this.props);
    return /*#__PURE__*/React.createElement(NotFoundRender, mergeProps);
  };
  _proto.renderSearching = function renderSearching() {
    var mergeProps = mergeGlobalConfig(this.props);
    return /*#__PURE__*/React.createElement(SearchingRender, mergeProps);
  };
  _proto.renderSearchFailed = function renderSearchFailed() {
    var mergeProps = mergeGlobalConfig(this.props);
    return /*#__PURE__*/React.createElement(SearchFailedRender, mergeProps);
  };
  _proto.renderCascader = function renderCascader() {
    var _this17 = this;
    var mergeProps = mergeGlobalConfig(this.props);
    var _this$state3 = this.state,
      dataSource = _this$state3.dataSource,
      searchLoading = _this$state3.searchLoading,
      searchValue = _this$state3.searchValue,
      searchResult = _this$state3.searchResult;
    if (dataSource.length === 0) {
      return this.renderNotFound();
    }
    var filteredPaths = [];
    if (searchValue) {
      var _mergeProps$config;
      if (((_mergeProps$config = mergeProps.config) === null || _mergeProps$config === void 0 ? void 0 : _mergeProps$config.apiModel) === 'cdn') {
        filteredPaths = this.filterItems();
      } else {
        filteredPaths = searchResult;
      }
      if (filteredPaths.length === 0 && !searchLoading) {
        var _mergeProps$config2;
        if (((_mergeProps$config2 = mergeProps.config) === null || _mergeProps$config2 === void 0 ? void 0 : _mergeProps$config2.apiModel) === 'cdn') {
          return this.renderNotFound();
        } else {
          return this.renderSearchFailed();
        }
      }
      if (searchLoading) {
        return this.renderSearching();
      }
    }
    var multiple = mergeProps.multiple,
      useVirtual = mergeProps.useVirtual,
      changeOnSelect = mergeProps.changeOnSelect,
      checkStrictly = mergeProps.checkStrictly,
      canOnlyCheckLeaf = mergeProps.canOnlyCheckLeaf,
      defaultExpandedValue = mergeProps.defaultExpandedValue,
      expandTriggerType = mergeProps.expandTriggerType,
      _onExpand = mergeProps.onExpand,
      readOnly = mergeProps.readOnly,
      listStyle = mergeProps.listStyle,
      listClassName = mergeProps.listClassName,
      showSearch = mergeProps.showSearch,
      markedDeletion = mergeProps.markedDeletion,
      _mergeProps$itemRende = mergeProps.itemRender,
      itemRender = _mergeProps$itemRende === void 0 ? function (item) {
        return /*#__PURE__*/React.createElement("span", {
          className: item.disable && markedDeletion ? 'cn-address--mark-deletion' : '',
          title: item.label
        }, item.label);
      } : _mergeProps$itemRende,
      _mergeProps$resultRen = mergeProps.resultRender,
      resultRender = _mergeProps$resultRen === void 0 ? function (searchValue, path) {
        var parts = [];
        var disable = false;
        path.forEach(function (item, i) {
          if (item.disable) disable = true;
          if (!item.label) return '';
          var reExp = searchValue.replace(/[-.+*?^$()[\]{}|\\]/g, function (v) {
            return "\\" + v;
          });
          var re = new RegExp(reExp, 'gi');
          var others = item.label.split(re);
          var matches = item.label.match(re);
          others.forEach(function (other, j) {
            if (other) {
              parts.push(other);
            }
            if (j < others.length - 1) {
              parts.push( /*#__PURE__*/React.createElement("em", {
                key: i + "-" + j
              }, matches[j]));
            }
          });
          if (i < path.length - 1) {
            parts.push(' / ');
          }
        });
        return /*#__PURE__*/React.createElement("span", {
          className: disable && markedDeletion ? 'cn-address--mark-deletion' : ''
        }, parts);
      } : _mergeProps$resultRen,
      immutable = mergeProps.immutable,
      _mergeProps$config$ap2 = mergeProps.config.apiModel,
      apiModel = _mergeProps$config$ap2 === void 0 ? 'mtop' : _mergeProps$config$ap2;
    var _this$state4 = this.state,
      value = _this$state4.value,
      expand = _this$state4.expand;
    var props = {
      dataSource: dataSource,
      value: value,
      expandedValue: expand,
      multiple: multiple,
      useVirtual: useVirtual,
      canOnlySelectLeaf: !changeOnSelect,
      checkStrictly: checkStrictly,
      canOnlyCheckLeaf: canOnlyCheckLeaf,
      defaultExpandedValue: defaultExpandedValue,
      expandTriggerType: expandTriggerType,
      ref: this.saveCascaderRef,
      onExpand: function onExpand(v) {
        var _this17$_v2n$v;
        var len = v.length;
        if (!((_this17$_v2n$v = _this17._v2n[v[len - 1]]) !== null && _this17$_v2n$v !== void 0 && _this17$_v2n$v.children)) {
          return;
        }
        _this17.setState({
          showExpandCount: len + 1,
          expandCount: len + 1,
          expand: v
        });
        _onExpand && _onExpand(v);
      },
      listStyle: listStyle,
      listClassName: classNames(listClassName, "cn-address-list"),
      loadData: apiModel === 'cdn' ? null : this.onLoadData.bind(this),
      resultRender: resultRender,
      itemRender: itemRender,
      immutable: immutable,
      v2n: this._v2n,
      p2n: this._p2n
    };
    if ('expandedValue' in mergeProps) {
      props.expandedValue = mergeProps.expandedValue;
    }
    if (!readOnly) {
      props.onChange = this.handleChange;
      props.onSelect = this.handleSelect;
    }
    if (showSearch) {
      props.searchValue = searchValue;
      props.filteredPaths = filteredPaths;
      props.resultRender = resultRender;
      props.filteredListStyle = {
        height: this.cascaderHeight
      };
    }
    return /*#__PURE__*/React.createElement(Cascader, props);
  };
  _proto.onLoadData = /*#__PURE__*/function () {
    var _onLoadData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(item) {
      var mergeProps, dataSource, iso, blackList, needSkipLevelData, pos, code, cur, res, realLevel, list, filterList;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            mergeProps = mergeGlobalConfig(this.props);
            dataSource = this.state.dataSource;
            iso = mergeProps.iso, blackList = mergeProps.blackList, needSkipLevelData = mergeProps.needSkipLevelData;
            pos = item.pos, code = item.value;
            cur = (this._v2n || {})[code]; // 一定会有cur 这里是点击触发的
            if (!(!cur || !cur.children || cur.children.length === 0)) {
              _context8.next = 15;
              break;
            }
            _context8.next = 8;
            return this.services.getChildren({
              id: code,
              iso: iso || item.iso,
              divisionLevel: item.rawLevel || item.level
            });
          case 8:
            res = _context8.sent;
            realLevel = getFinallyLevel(mergeProps, iso);
            list = (res || []).filter(function (i) {
              i.rawLevel = i.level;
              i.level = pos === null || pos === void 0 ? void 0 : pos.split('-').length; // 根据当前已有层级，设置下一级level值

              var l = needSkipLevelData ? i.level : i.rawLevel;
              return l <= realLevel;
            });
            filterList = []; // 过滤黑名单区域
            filterList = list.filter(function (item) {
              return !blackList.includes(item.id);
            });
            // 白名单
            filterList = this._fiterDataForWhitelist(filterList);
            this.mergeDataSource(dataSource, filterList, pos);
          case 15:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this);
    }));
    function onLoadData(_x7) {
      return _onLoadData.apply(this, arguments);
    }
    return onLoadData;
  }();
  _proto.mergeDataSource = function mergeDataSource(source, item, pos) {
    var mergeProps = mergeGlobalConfig(this.props);
    var maxLevel = mergeProps.maxLevel,
      showDisabledDivision = mergeProps.showDisabledDivision,
      dataLanguage = mergeProps.dataLanguage,
      needSkipLevelData = mergeProps.needSkipLevelData,
      divisionSort = mergeProps.divisionSort,
      levelConfig = mergeProps.levelConfig,
      iso = mergeProps.iso,
      isShowAbroad = mergeProps.isShowAbroad;

    // 是否为全部国家
    var maxDataLevel = getFinallyLevel(mergeProps);
    var newData = [].concat(source);
    var posList = pos.split('-');
    var len = posList.length;
    posList = posList.splice(1);
    var next = {};
    posList.forEach(function (level, index) {
      if (index === 0) {
        next = newData[level];
      } else {
        next = next.children[level];
      }
    });
    if (item.length !== 0) {
      var _next;
      if (!next.children) next.children = handleData({
        input: item,
        isLeaf: maxLevel <= len,
        parentId: (_next = next) === null || _next === void 0 ? void 0 : _next.value,
        showDisabledDivision: showDisabledDivision,
        dataLanguage: dataLanguage,
        maxDataLevel: maxDataLevel,
        needSkipLevelData: needSkipLevelData,
        divisionSort: divisionSort,
        levelConfig: levelConfig,
        iso: iso,
        isShowAbroad: isShowAbroad
      });
    } else {
      next.isLeaf = true;
    }
    this.setState({
      dataSource: newData
    });
    this.preHandleData(newData);
  };
  _proto.batchHandleCheck = function batchHandleCheck(vs, checked, value) {
    if (!vs.length) return value;
    var mergeProps = mergeGlobalConfig(this.props);
    var checkStrictly = mergeProps.checkStrictly,
      canOnlyCheckLeaf = mergeProps.canOnlyCheckLeaf;
    var v2n = this._v2n || {};
    var p2n = this._p2n || {};
    if (checkStrictly || canOnlyCheckLeaf) {
      processValue(value, vs, checked);
    } else {
      var valueDict = genDict(value);
      var processV1 = [];
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i];
        forEachEnableNode(v2n[v], function (node) {
          if (node.checkable === false) return;
          processV1.push(node.value);
          // processValue(value, node.value, checked);
        });
      }

      processValue(value, processV1, checked, valueDict);
      valueDict = genDict(value);
      var pos = this.getPos(vs[0]);
      var ps = Object.keys(p2n);
      var currentPos = pos;
      var nums = pos.split('-');
      for (var _i = nums.length; _i > 2; _i--) {
        var parentCheck = true;
        var parentPos = nums.slice(0, _i - 1).join('-');
        if (p2n[parentPos].disabled || p2n[parentPos].checkboxDisabled || p2n[parentPos].checkable === false) {
          currentPos = parentPos;
          continue;
        }
        var parentValue = p2n[parentPos].value;
        // const parentChecked = value.indexOf(parentValue) > -1;
        var parentChecked = valueDict[parentValue];
        if (!checked && !isNumber(parentChecked)) {
          break;
        }
        for (var j = 0; j < ps.length; j++) {
          var p = ps[j];
          var pnode = p2n[p];
          if (isSiblingOrSelf(currentPos, p) && !pnode.disabled && !pnode.checkboxDisabled) {
            var k = pnode.value;
            if (pnode.checkable === false) {
              if (!pnode.children || pnode.children.length === 0) {
                continue;
              }
              for (var m = 0; m < pnode.children.length; m++) {
                if (!pnode.children.every(function (child) {
                  return isNodeChecked(child, value);
                })) {
                  parentCheck = false;
                  break;
                }
              }
            } else if (!isNumber(valueDict[k])) {
              parentCheck = false;
            }
            if (!parentCheck) break;
          }
        }

        // todo 可能有性能问题，批量优化
        processValue(value, parentValue, parentCheck, valueDict);
        valueDict = genDict(value);
        currentPos = parentPos;
      }
    }
    return value;
  };
  _proto.flatValueFn = function flatValueFn(value) {
    var v2n = this._v2n;
    var p2n = this._p2n;
    return filterChildValue(value, v2n, p2n);
  };
  _proto.batchChange = function batchChange(tempValue, checkStrictly, canOnlyCheckLeaf) {
    if (checkStrictly || canOnlyCheckLeaf) {
      var data = this.getData(tempValue);
      this.handleChange(tempValue, data, {
        checkedData: data
      });
    } else {
      // flat 用于扁平
      // complete 用于补全
      var flatValue = this.flatValueFn(tempValue);
      var flatData = this.getData(flatValue);
      var checkedData = this.getData(tempValue);
      var indeterminateValue = this.getIndeterminate(this.state.value);
      var indeterminateData = this.getData(indeterminateValue);
      this.handleChange(flatValue, flatData, {
        checkedData: checkedData,
        indeterminateData: indeterminateData
      });
    }
  };
  _proto.onChoose = function onChoose(index, type) {
    var _this$cascader, _this$cascader$_insta, _this$cascader$_insta2;
    var mergeProps = mergeGlobalConfig(this.props);
    var _this$state5 = this.state,
      expand = _this$state5.expand,
      value = _this$state5.value,
      dataSource = _this$state5.dataSource;
    var checkStrictly = mergeProps.checkStrictly,
      canOnlyCheckLeaf = mergeProps.canOnlyCheckLeaf;

    // cn-ui与next获取形式不同，兼容
    var tempValue = ((_this$cascader = this.cascader) === null || _this$cascader === void 0 ? void 0 : (_this$cascader$_insta = _this$cascader._instance) === null || _this$cascader$_insta === void 0 ? void 0 : (_this$cascader$_insta2 = _this$cascader$_insta.state) === null || _this$cascader$_insta2 === void 0 ? void 0 : _this$cascader$_insta2.value) || this.cascader.state.value;
    var v2n = this._v2n;
    var parentCode = expand[index - 1];
    var parentLevelInfo = v2n[parentCode];
    var shouldDel = [];
    var shouldCheck = [];
    if (type === 'all') {
      if (checkStrictly) {
        var temp = (parentLevelInfo === null || parentLevelInfo === void 0 ? void 0 : parentLevelInfo.children) || [];
        if (index === 0) {
          temp = temp.concat(dataSource);
        }
        temp.map(function (i) {
          shouldCheck.push(i.value);
        });
        tempValue = this.batchHandleCheck(shouldCheck, true, tempValue);
        this.batchChange(tempValue, checkStrictly, canOnlyCheckLeaf);
        return;
      } else if (canOnlyCheckLeaf) {
        ((parentLevelInfo === null || parentLevelInfo === void 0 ? void 0 : parentLevelInfo.children) || []).map(function (i) {
          if (i.isLeaf) {
            shouldCheck.push(i.value);
          } else {
            shouldDel.push(i.value);
          }
        });
        tempValue = this.batchHandleCheck(shouldCheck, true, tempValue);
        tempValue = this.batchHandleCheck(shouldDel, false, tempValue);
        this.batchChange(tempValue, checkStrictly, canOnlyCheckLeaf);
        return;
      } else {
        if (index === 0) {
          var _shouldCheck = [];
          dataSource.map(function (i) {
            _shouldCheck.push(i.value);
          });
          tempValue = this.batchHandleCheck(_shouldCheck, true, tempValue);
          this.batchChange(tempValue);
          return;
        }
        ((parentLevelInfo === null || parentLevelInfo === void 0 ? void 0 : parentLevelInfo.children) || []).map(function (i) {
          shouldCheck.push(i.value);
        });
        tempValue = this.batchHandleCheck(shouldCheck, true, tempValue);
        this.batchChange(tempValue);
      }
      return;
    }
    if (type === 'reverse') {
      if (index === 0) {
        var map = {};
        dataSource.map(function (i) {
          i.check = true;
          if (canOnlyCheckLeaf && !i.isLeaf) return;
          if (!map[i.value]) map[i.value] = i;
        });
        value.map(function (o) {
          if (map[o]) {
            map[o].check = false;
          }
        });
        Object.values(map).map(function (i) {
          if (i.check) {
            shouldCheck.push(i.value);
          } else {
            shouldDel.push(i.value);
          }
        });
        tempValue = this.batchHandleCheck(shouldCheck, true, tempValue);
        tempValue = this.batchHandleCheck(shouldDel, false, tempValue);
        this.batchChange(tempValue, checkStrictly, canOnlyCheckLeaf);
        return;
      }
      if (checkStrictly || canOnlyCheckLeaf) {
        var allCur = [];
        if (checkStrictly) allCur = parentLevelInfo.children;
        if (canOnlyCheckLeaf) allCur = parentLevelInfo.children.filter(function (i) {
          return i.isLeaf;
        });
        allCur.map(function (i) {
          if (i !== null && i !== void 0 && i.value) {
            if (!value.includes(i.value)) {
              shouldCheck.push(i.value);
            } else {
              shouldDel.push(i.value);
            }
          }
        });
        tempValue = this.batchHandleCheck(shouldCheck, true, tempValue);
        tempValue = this.batchHandleCheck(shouldDel, false, tempValue);
        this.batchChange(tempValue, checkStrictly, canOnlyCheckLeaf);
        return;
      } else {
        var _allCur = (parentLevelInfo === null || parentLevelInfo === void 0 ? void 0 : parentLevelInfo.children) || [];
        var valueDict = genDict(tempValue);
        _allCur.map(function (i) {
          if (i !== null && i !== void 0 && i.value) {
            if (!isNumber(valueDict[i.value])) {
              shouldCheck.push(i.value);
            } else {
              shouldDel.push(i.value);
            }
          }
        });
        tempValue = this.batchHandleCheck(shouldCheck, true, tempValue);
        tempValue = this.batchHandleCheck(shouldDel, false, tempValue);
        this.batchChange(tempValue);
        return;
      }
    }
    if (type === 'clear') {
      if (index === 0) {
        if (checkStrictly || canOnlyCheckLeaf) {
          dataSource.map(function (i) {
            shouldDel.push(i.value);
          });
          tempValue = this.batchHandleCheck(shouldDel, false, tempValue);
          this.batchChange(tempValue, checkStrictly, canOnlyCheckLeaf);
        } else {
          this.batchChange([]);
        }
        return;
      }
      parentLevelInfo.children.map(function (i) {
        shouldDel.push(i.value);
      });
      tempValue = this.batchHandleCheck(shouldDel, false, tempValue);
      this.batchChange(tempValue, checkStrictly, canOnlyCheckLeaf);
    }
  };
  _proto.renderPopupContent = function renderPopupContent() {
    var mergeProps = mergeGlobalConfig(this.props);
    var prefix = mergeProps.prefix,
      header = mergeProps.header,
      footer = mergeProps.footer,
      iso = mergeProps.iso,
      locale = mergeProps.locale,
      multiple = mergeProps.multiple,
      maxLevel = mergeProps.maxLevel,
      apiModel = mergeProps.config.apiModel,
      showFooter = mergeProps.showFooter;
    var showExpandCount = this.state.showExpandCount;
    return /*#__PURE__*/React.createElement("div", {
      className: prefix + "cascader-select-dropdown"
    }, header, this.renderCascader(), footer ? footer : multiple && showFooter ? /*#__PURE__*/React.createElement(Footer, {
      locale: locale,
      apiModel: apiModel,
      maxLevel: maxLevel,
      iso: iso,
      count: showExpandCount,
      onChoose: this.onChoose.bind(this)
    }) : null);
  };
  _proto.renderPreview = function renderPreview(others) {
    var mergeProps = mergeGlobalConfig(this.props);
    var prefix = mergeProps.prefix,
      multiple = mergeProps.multiple,
      className = mergeProps.className,
      renderPreview = mergeProps.renderPreview,
      readOnlyProps = mergeProps.readOnlyProps;
    var value = this.state.value;
    var previewCls = classNames(className, prefix + "form-preview");
    var items = (multiple ? this.getMultipleData(value) : this.getSingleData(value)) || [];
    if (!Array.isArray(items)) {
      items = [items];
    }
    if (typeof renderPreview === 'function') {
      return /*#__PURE__*/React.createElement("div", {
        className: previewCls
      }, renderPreview(items, mergeProps));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: previewCls
    }, items.length > 0 && /*#__PURE__*/React.createElement(CnReadOnly
    // showFolder
    , _extends({
      value: items.map(function (_ref3) {
        var label = _ref3.label;
        return label;
      }).join(', ')
    }, readOnlyProps)));
  };
  _proto.render = function render() {
    var _this18 = this;
    var mergeProps = mergeGlobalConfig(this.props);
    var locale = mergeProps.locale,
      prefix = mergeProps.prefix,
      size = mergeProps.size,
      hasArrow = mergeProps.hasArrow,
      hasBorder = mergeProps.hasBorder,
      hasClear = mergeProps.hasClear,
      label = mergeProps.label,
      placeholder = mergeProps.placeholder,
      className = mergeProps.className,
      showSearch = mergeProps.showSearch,
      popupStyle = mergeProps.popupStyle,
      popupClassName = mergeProps.popupClassName,
      popupContainer = mergeProps.popupContainer,
      popupProps = mergeProps.popupProps,
      followTrigger = mergeProps.followTrigger,
      resultAutoWidth = mergeProps.resultAutoWidth,
      tagInline = mergeProps.tagInline,
      maxTagPlaceholder = mergeProps.maxTagPlaceholder,
      style = mergeProps.style,
      maxTagCount = mergeProps.maxTagCount,
      _mergeProps$config$ap3 = mergeProps.config.apiModel,
      apiModel = _mergeProps$config$ap3 === void 0 ? 'mtop' : _mergeProps$config$ap3,
      isParseSearch = mergeProps.isParseSearch,
      isSearchById = mergeProps.isSearchById;
    var _this$props2 = this.props,
      multiple = _this$props2.multiple,
      disabled = _this$props2.disabled,
      iso = _this$props2.iso,
      readOnly = _this$props2.readOnly;
    var _this$state6 = this.state,
      value = _this$state6.value,
      searchValue = _this$state6.searchValue,
      visible = _this$state6.visible,
      initLoading = _this$state6.initLoading,
      searchLoading = _this$state6.searchLoading;
    var others = pickOthers(Object.keys(CnAddress.propTypes), mergeProps);
    if (readOnly) {
      return this.renderPreview(others);
    }
    var popupContent = this.renderPopupContent();
    var props = {
      tagInline: tagInline,
      prefix: prefix,
      className: classNames(className, "cn-address"),
      size: size,
      placeholder: placeholder,
      disabled: disabled,
      hasArrow: hasArrow,
      hasBorder: hasBorder,
      hasClear: hasClear,
      label: label,
      readOnly: readOnly,
      autoWidth: false,
      mode: multiple ? 'multiple' : 'single',
      value: multiple ? this.getMultipleData(value) : this.getSingleData(value),
      onChange: this.handleClear,
      onRemove: this.handleRemove,
      visible: visible,
      onVisibleChange: this.handleVisibleChange,
      showSearch: showSearch,
      onSearch: this.handleSearch,
      onKeyDown: this.handleKeyDown,
      popupContent: popupContent,
      popupStyle: popupStyle,
      popupClassName: classNames(popupClassName, "cn-address-popup"),
      popupContainer: popupContainer,
      popupProps: popupProps,
      followTrigger: followTrigger,
      maxTagCount: maxTagCount
    };
    if (initLoading || searchLoading) props.state = 'loading';
    if (showSearch && apiModel === 'mtop') {
      props.popupProps = _extends({}, popupProps, {
        ref: this.getPopup,
        afterOpen: this.handleAfterOpen
      });
      props.autoWidth = resultAutoWidth && !!searchValue;
    }
    var maxTagPlaceholder2 = function maxTagPlaceholder2(selectedValues) {
      var arrValue = transferObjToAvailable(value, _extends({}, mergeProps));
      var labels = _this18.getData(arrValue).map(function (o) {
        return o === null || o === void 0 ? void 0 : o.label;
      }).filter(function (item) {
        return item;
      });
      // 使用labels非 selectedValues，因为可能传入id不存在
      var trigger = /*#__PURE__*/React.createElement("span", null, locale.selected, "\xA0", labels.length, "\xA0", locale.total);
      return /*#__PURE__*/React.createElement(CnTooltip, {
        trigger: trigger
      }, labels && labels.join(', '));
    };
    if ('maxTagPlaceholder' in mergeProps) {
      props.maxTagPlaceholder = maxTagPlaceholder;
    } else {
      props.maxTagPlaceholder = maxTagPlaceholder2;
    }
    if ('placeholder' in mergeProps) {
      props.placeholder = placeholder;
    } else {
      props.placeholder = locale.placeholder;
    }
    if ('style' in mergeProps) {
      props.style = style;
    }
    if (visible && showSearch && isParseSearch && iso === 'CN') {
      props.innerAfter = /*#__PURE__*/React.createElement(Icon, {
        type: "filter",
        title: locale.parseSearchIcon,
        style: {
          marginTop: 2,
          marginRight: 4,
          color: '#999'
        }
      });
    }
    if (visible && showSearch && isSearchById) {
      props.innerAfter = /*#__PURE__*/React.createElement(Icon, {
        className: "cn-address-suffix-icon",
        type: "attachment",
        title: locale.idSearchIcon
      });
    }
    return /*#__PURE__*/React.createElement(Select, _extends({
      ref: this.saveSelectRef
    }, props));
  };
  return CnAddress;
}(Component);
CnAddress.propTypes = {
  prefix: PropTypes.string,
  pure: PropTypes.bool,
  className: PropTypes.string,
  /**
   * 选择框大小
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * 选择框占位符
   */
  placeholder: PropTypes.string,
  /**
   * 是否禁用
   */
  disabled: PropTypes.bool,
  /**
   * 是否有下拉箭头
   */
  hasArrow: PropTypes.bool,
  /**
   * 是否有边框
   */
  hasBorder: PropTypes.bool,
  /**
   * 是否有清除按钮
   */
  hasClear: PropTypes.bool,
  /**
   * 自定义内联 label
   */
  label: PropTypes.node,
  /**
   * 是否只读，只读模式下可以展开弹层但不能选。废除。
   * 调整形态，预览态，与isPreview形态一致
   */
  readOnly: PropTypes.bool,
  /**
   * （非受控）默认值
   */
  defaultValue: PropTypes.any,
  // PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /**
   * （受控）当前值
   */
  value: PropTypes.any,
  //PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /**
   * 选中值改变时触发的回调函数
   * @param {String|Array} value 选中的值，单选时返回单个值，多选时返回数组
   * @param {Object|Array} data 选中的数据，包括 value 和 label，单选时返回单个值，多选时返回数组，父子节点选中关联时，同时选中，只返回父节点
   * @param {Object} extra 额外参数
   * @param {Array} extra.selectedPath 单选时选中的数据的路径
   * @param {Boolean} extra.checked 多选时当前的操作是选中还是取消选中
   * @param {Object} extra.currentData 多选时当前操作的数据
   * @param {Array} extra.checkedData 多选时所有被选中的数据
   * @param {Array} extra.indeterminateData 多选时半选的数据
   */
  onChange: PropTypes.func,
  /**
   * 默认展开值，如果不设置，组件内部会根据 defaultValue/value 进行自动设置
   */
  defaultExpandedValue: PropTypes.arrayOf(PropTypes.string),
  /**
   * （受控）当前展开值
   */
  expandedValue: PropTypes.arrayOf(PropTypes.string),
  /**
   * 展开触发的方式
   */
  expandTriggerType: PropTypes.oneOf(['click', 'hover']),
  onExpand: PropTypes.func,
  /**
   * 是否开启虚拟滚动
   */
  useVirtual: PropTypes.bool,
  /**
   * 是否多选
   */
  multiple: PropTypes.bool,
  /**
   * 是否选中即发生改变, 该属性仅在单选模式下有效
   */
  changeOnSelect: PropTypes.bool,
  /**
   * 是否只能勾选叶子项的checkbox，该属性仅在多选模式下有效
   */
  canOnlyCheckLeaf: PropTypes.bool,
  /**
   * 父子节点是否选中不关联
   */
  checkStrictly: PropTypes.bool,
  /**
   * 每列列表样式对象
   */
  listStyle: PropTypes.object,
  /**
   * 每列列表类名
   */
  listClassName: PropTypes.string,
  /**
   * 选择框单选时展示结果的自定义渲染函数
   * @param {Array} label 选中路径的文本数组
   * @return {ReactNode} 渲染在选择框中的内容
   * @default 单选时：labelPath => labelPath.join(' / ')；多选时：labelPath => labelPath[labelPath.length - 1]
   */
  displayRender: PropTypes.func,
  /**
   * 渲染 item 内容的方法
   * @param {Object} item 渲染节点的item
   * @return {ReactNode} item node
   */
  itemRender: PropTypes.func,
  /**
   * 是否显示搜索框
   */
  showSearch: PropTypes.bool,
  /**
   * 自定义搜索函数
   * @param {String} searchValue 搜索的关键字
   * @param {Array} path 节点路径
   * @return {Boolean} 是否匹配
   * @default 根据路径所有节点的文本值模糊匹配
   */
  filter: PropTypes.func,
  /**
   * 当搜索框值变化时回调
   * @param {String} value 数据
   * @version 1.23
   */
  onSearch: PropTypes.func,
  /**
   * 搜索结果自定义渲染函数
   * @param {String} searchValue 搜索的关键字
   * @param {Array} path 匹配到的节点路径
   * @return {ReactNode} 渲染的内容
   * @default 按照节点文本 a / b / c 的模式渲染
   */
  resultRender: PropTypes.func,
  /**
   * 搜索结果列表是否和选择框等宽
   */
  resultAutoWidth: PropTypes.bool,
  /**
   * 无数据时显示内容
   */
  notFoundContent: PropTypes.node,
  /**
   * 异步加载数据函数
   * @param {Object} data 当前点击异步加载的数据
   */
  loadData: PropTypes.func,
  /**
   * 自定义下拉框头部
   */
  header: PropTypes.node,
  /**
   * 自定义下拉框底部
   */
  footer: PropTypes.node,
  /**
   * 初始下拉框是否显示
   */
  defaultVisible: PropTypes.bool,
  /**
   * 当前下拉框是否显示
   */
  visible: PropTypes.bool,
  /**
   * 下拉框显示或关闭时触发事件的回调函数
   * @param {Boolean} visible 是否显示
   * @param {String} type 触发显示关闭的操作类型, fromTrigger 表示由trigger的点击触发； docClick 表示由document的点击触发
   */
  onVisibleChange: PropTypes.func,
  /**
   * 下拉框自定义样式对象
   */
  popupStyle: PropTypes.object,
  /**
   * 下拉框样式自定义类名
   */
  popupClassName: PropTypes.string,
  /**
   * 下拉框挂载的容器节点
   */
  popupContainer: PropTypes.any,
  /**
   * 透传到 Popup 的属性对象
   */
  popupProps: PropTypes.object,
  /**
   * 是否跟随滚动
   */
  followTrigger: PropTypes.bool,
  /**
   * 是否为预览态
   */
  // isPreview: PropTypes.bool,
  /**
   * 预览态模式下渲染的内容
   * @param {Array<data>} value 选择值 { label: , value:}
   */
  renderPreview: PropTypes.func,
  /**
   * 是否是不可变数据
   * @version 1.23
   */
  immutable: PropTypes.bool,
  /**
   * 可选区划层级
   */
  maxLevel: PropTypes.number,
  /**
   * value 使用对象类型, 同时 onChange 第一个参数返回也修改为对象类型
   */
  useDetailValue: PropTypes.bool,
  /**
   * useDetailValue开启时 详细数据映射表
   */
  useDetailMap: PropTypes.object,
  /**
   * 是否开启解析搜索，仅国内区划生效，iso=CN
   */
  isParseSearch: PropTypes.bool,
  /**
   * 是否开启ID搜索
   */
  isSearchById: PropTypes.bool,
  /**
   * 是否显示【中国】下【海外】
   */
  isShowAbroad: PropTypes.bool,
  /**
   * 屏蔽敏感数据
   */
  hideSensitiveDivision: PropTypes.bool,
  /**
   * 搜索严格模式，限制层级
   */
  searchStrictly: PropTypes.bool
};
CnAddress.defaultProps = {
  prefix: 'cn-next-',
  locale: zhCN,
  iso: 'CN',
  dataLanguage: 'CN',
  pure: false,
  size: 'medium',
  disabled: false,
  hasArrow: true,
  hasBorder: true,
  hasClear: false,
  defaultValue: null,
  expandTriggerType: 'click',
  onExpand: function onExpand() {},
  useVirtual: false,
  multiple: false,
  changeOnSelect: false,
  canOnlyCheckLeaf: false,
  checkStrictly: false,
  showTopLevel: false,
  showFooter: false,
  divisionSort: '',
  maxLevel: 4,
  showSearch: false,
  needSkipLevelData: true,
  showDisabledDivision: false,
  markedDeletion: false,
  includeList: [],
  excludeList: [],
  blackList: [],
  whitelistCode: '',
  config: {
    apiModel: 'mtop',
    isJsonpForMtop: false
  },
  useDetailValue: false,
  isParseSearch: false,
  isSearchById: false,
  isShowAbroad: false,
  filter: function filter(searchValue, path) {
    return path.some(function (item) {
      return String(item.label).toLowerCase().indexOf(String(searchValue).toLowerCase()) > -1;
    });
  },
  resultAutoWidth: true,
  defaultVisible: false,
  onchange: function onchange() {},
  onVisibleChange: function onVisibleChange() {},
  popupProps: {},
  immutable: false,
  hideSensitiveDivision: true,
  searchStrictly: true
};
export default CnAddress;